import { Component, ViewEncapsulation } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../_services';
import Swal from 'sweetalert2'
import { Broadcaster } from 'environments/broadcaster';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';//added by kuldeep on 10-03-2018
import {MomentDateAdapter} from '@angular/material-moment-adapter';//added by kuldeep on 10-03-2018
import * as _moment from 'moment'; //added by kuldeep on 10-03-2018
import * as _rollupMoment from 'moment';//added by kuldeep on 10-03-2018
 
const moment = _rollupMoment || _moment;
import { LoaderService } from '../../../_services/loader.service';
import { process, State } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { GroupDescriptor } from '@progress/kendo-data-query';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

declare var $: any;
@Component({
  selector: 'app-kccReq',
  templateUrl: './kccRequests.component.html',
  styleUrls: ['./kccRequests.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class KccReqComponent {
  prjId: any
  public reqLists: any[];
  showLoader: boolean;
  dataRangeModal: any;
  userId:any

  public state: State = {
    skip: 0,
    take: 100,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public pageSize: any
  public checkboxOnly = false;
  public mode = 'multiple';
  public selectableSettings: SelectableSettings;

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridDataReq: any;
  public hiddenColumns: string[] = [];
  rejectRemarks: any;
  invId: any;
  consumerID: any;
  public isHidden(columnName: string): boolean {
    return this.hiddenColumns.indexOf(columnName) > -1;
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  private loadProducts(): void {
    this.gridDataReq = process(this.reqLists, { group: this.groups });
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.reqLists
    };
    return result;
  }


  constructor(private sanitizer: DomSanitizer ,private broadcaster: Broadcaster, private auth: AuthService, private http : HttpClient , private routes: ActivatedRoute, private router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.allData = this.allData.bind(this);
  }


  getRequests(type) {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'invoice/getInvoiceConversionRequests?prjId='+ this.prjId + '&reqTaxInvStatus='+ type).subscribe(data => {
      var result:any
      result = data
      this.reqLists = result
      this.gridDataReq = process(this.reqLists, this.state);
      this.loaderService.display(false);
    });
  }
  
  acceptRequest(data) {
    data ={
        ID: data.ID,
        PRJID: this.prjId,
        USERID: this.userId,
        invoiceType: 1
    }
    console.log(data)
    Swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Convert it!'
      })
      .then((result) => {
        if (result.value) {
          if(result.value == true){
            setTimeout(() => {
              this.getRequests('Requested');
              Swal({
                title: 'Accepted',
                text: "Request has been accepted!",
                type: 'success',
                showCancelButton: false
              })
            }, 1000);
          }
          this.http.post(environment.apiUrl + 'invoice/approveConvertInvoice', data).subscribe((data) => {
            var response: any;
            response = data;
            var status = response.output[0].RESPONSECODE;
            setTimeout(() => {
              this.getRequests('Requested');
            }, 1000);
            if (status == 200) {
              var msg = response.output[1].RESPONSEMESSAGE;
              Swal(response.output[2].INVOICENO_RESPONSE, msg, 'success');
              setTimeout(() => {
                this.getRequests('Requested');
              }, 1000);
            } else {
              var msg = response.output[1].RESPONSEMESSAGE;
              Swal(msg, 'error');
              setTimeout(() => {
                this.getRequests('Requested');
              }, 1000);
            }
          });
        }
      });
    
      this.getRequests('Requested');
  }

  clearDeatils(){
    this.invId = null
    this.rejectRemarks = null
    this.invId = null
    this.invId = null
  }

  rejectRequestModal(data){
    this.clearDeatils();
    this.invId = data.ID
    this.consumerID = data.CONSUMERID
    this.rejectRemarks = this.rejectRemarks
    console.log("Reject data ======================== " + this.invId, this.rejectRemarks)
    $('#rejectModal').modal('show');
  }
  
  rejectRequest() {
    var data ={
        ID: this.invId,
        rejectRemarks: this.rejectRemarks,
    }
    Swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Reject it!'
      })
      .then((result) => {
        if (result.value) {
          if(result.value == true){
            setTimeout(() => {
              this.getRequests('Requested');
              Swal({
                title: 'Reject?',
                text: "Request has been rejected!",
                type: 'success',
                showCancelButton: false
              })
            }, 1000);
          }
          this.http.post(environment.apiUrl + 'invoice/rejectConvertInvoice', data).subscribe((data) => {
            var response: any;
            response = data;
            var status = response.output[0].RESPONSECODE;
            setTimeout(() => {
              this.getRequests('Requested');
            }, 1000);
            if (status == 200) {
              var msg = response.output[1].RESPONSEMESSAGE;
              Swal(response.output[2].INVOICENO_RESPONSE, msg, 'success');
              setTimeout(() => {
                this.getRequests('Requested');
              }, 1000);
            } else {
              var msg = response.output[1].RESPONSEMESSAGE;
              Swal(msg, 'error');
              setTimeout(() => {
                this.getRequests('Requested');
              }, 1000);
            }
          });
        }
      });
    
      this.getRequests('Requested');
  }

  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.getRequests('Requested')
  }
}


// WEBPACK FOOTER //
// ./src/app/crm/kcc/kccRequests/kccRequests.component.ts